import { useTopics } from '@/queries/articles';
import styles from './TopicSelect.module.scss';

interface TopicSelectProps {
  value: string | null | undefined;
  onChange: (value: string | null) => void;
  placeholder?: string;
}

export function TopicSelect({ value, onChange, placeholder = 'Select a topic' }: TopicSelectProps) {
  const { data: topics, isLoading } = useTopics();

  return (
    <select
      className={styles.select}
      value={value || ''}
      onChange={(e) => onChange(e.target.value || null)}
      disabled={isLoading}
    >
      <option value="">{isLoading ? 'Loading...' : placeholder}</option>
      {topics?.map((topic) => (
        <option key={topic.id} value={topic.name}>
          {topic.name}
        </option>
      ))}
    </select>
  );
}
